export default class Mainvisual {
    constructor() {
        //this.init();
    }

    init() {
        this.kvChange();
    }

    kvChange() {
        const duration = 10000;

        setInterval(() => {
            const kvID = document.body.getAttribute("data-kvmakyou");

            if (kvID === "1") {
                document.body.setAttribute("data-kvmakyou", "2");
            } else {
                document.body.setAttribute("data-kvmakyou", "1");
            }
        }, duration);

    }

    resetKv() {
        document.body.setAttribute("data-kvmakyou", "1");
    }
}